(function () {
  'use strict';

  /* ── Floating-buttons controller ───────────────────────────────────── */
  const containerRight = document.getElementById('FloatingButtons');
  const containerLeft = document.getElementById('FloatingButtonsLeft');
  if (!containerRight) return;

  /**
   * App-button definitions.
   * selector : CSS selector to find the app-injected element
   * id       : data-floating-btn value (used for styling hooks)
   * order    : DOM order inside the target flex container
   *            (column layout: lower = higher on screen)
   * target   : which container to adopt the element into
   */
  const APP_BUTTONS = [
    {
      selector: 'a[href="#swym-wishlist"]',
      id: 'swym',
      order: 1,
      target: containerRight,
      tooltip: 'Wishlist',
    },
    {
      selector: '#loloyal-launcher-box',
      id: 'loloyal',
      order: 0,
      target: containerLeft,
      tooltip: 'Rewards',
    },
  ];

  const collected = {};

  function adopt(def, el) {
    if (collected[def.id]) return; // already handled
    const target = def.target;
    if (!target) return;

    collected[def.id] = true;

    if (def.id === 'loloyal') {
      // ── Mobile: skip adoption entirely ───────────────────────────────────
      // Every overlay/proxy/click-dispatch strategy fails on mobile WebKit.
      // Loloyal's native button works fine on its own — stop interfering.
      const isMobile =
        /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
        (window.innerWidth <= 767 && 'ontouchstart' in window);
      if (isMobile) return;

      // ── Desktop: Loloyal overlay strategy ────────────────────────────────
      // Do NOT move Loloyal's element in the DOM. Loloyal's app-bridge
      // checks DOM position before firing the panel navigate.
      //
      // Programmatic .click() on shadow DOM internals is unreliable on
      // mobile Safari/WebKit — the old proxy-click approach worked on
      // desktop but failed on iOS Safari and Chrome Android.
      //
      // Strategy (overlay):
      //   1. Create a visual proxy <button> in our container (the star icon
      //      the user sees).
      //   2. Once shadow root is ready, reposition the real Loloyal host
      //      element directly over the proxy (same viewport coordinates).
      //   3. Make the host transparent and the inner .loloyal-launcher
      //      transparent but filling the host area with pointer-events:auto.
      //   4. Native taps hit .loloyal-launcher through browser hit-testing
      //      — Loloyal's own handler fires. Zero programmatic dispatch.
      //   5. The wrapper z-index (10002) ensures the host stacks above
      //      the proxy container (10001).

      // clip-path hides the host visually without affecting the panel's stacking
      // context or opacity inheritance — opacity:0 was making the panel invisible
      // even when opened, because the panel renders inside/relative to the host.
      el.style.setProperty('clip-path', 'inset(100%)', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');

      // The parent wrapper (.boom-launcher.loloyal-launcher-wrapper) is also
      // fixed-positioned at the bottom-left and intercepts pointer events in the
      // same area as our proxy button — making the proxy unclickable on hover.
      // We need careful event handling: block wrapper events, but allow panel iframe.
      const wrapper = el.parentElement;
      if (wrapper && wrapper !== document.body) {
        wrapper.style.setProperty('pointer-events', 'none', 'important');
        wrapper.style.setProperty('z-index', '10002', 'important');
        wrapper.style.setProperty('transform', 'none', 'important');

        // Re-enable pointer events on the panel element when it becomes visible.
        // Mobile: panel might use different class names; search more aggressively.
        function syncPanelPointerEvents() {
          // Primary selector: standard Loloyal panel
          let panel = wrapper.querySelector('.loloyal-iframe-page');

          // Fallback: any iframe inside the wrapper
          if (!panel) {
            const iframe = wrapper.querySelector('iframe');
            if (iframe) panel = iframe;
          }

          // Last resort: any child that isn't the launcher host itself
          if (!panel) {
            const children = wrapper.children;
            for (let c = 0; c < children.length; c++) {
              if (children[c] !== el) {
                panel = children[c];
                break;
              }
            }
          }

          if (!panel) return;

          const cs = window.getComputedStyle(panel);
          // Do NOT check clip-path here — Loloyal uses clip-path for its panel-open
          // animation, so a non-'none' clip-path means "animating open", not "hidden".
          // Treating an animating panel as hidden and writing pointer-events:none onto
          // the iframe blocks the lazy-load pointer event that triggers the coin-balance
          // fetch, causing the spinner to spin indefinitely.
          const isVisible =
            cs.display !== 'none' &&
            cs.visibility !== 'hidden' &&
            parseFloat(cs.opacity || '1') > 0;

          if (isVisible) {
            panel.style.setProperty('pointer-events', 'auto', 'important');
            panel.style.setProperty('z-index', '999999', 'important');
          }
          // Never write pointer-events:none onto the panel — the wrapper already
          // has pointer-events:none to block unintended wrapper interactions, and
          // pointer-events does not inherit, so the panel's default auto is intact.
        }

        // Watch only for child additions/removals (panel appearing or disappearing).
        // Do NOT observe subtree attribute changes — those fire on every CSS
        // transition frame and spam syncPanelPointerEvents during the open animation.
        new MutationObserver(syncPanelPointerEvents).observe(wrapper, {
          childList: true,
          subtree: true,
        });

        // Initial sync + periodic re-check (mobile may update async)
        syncPanelPointerEvents();
        setInterval(syncPanelPointerEvents, 500);
      }

      // Build proxy button using pure DOM methods (no innerHTML).
      const proxy = document.createElement('button');
      proxy.setAttribute('data-floating-btn', 'loloyal');
      proxy.setAttribute('data-floating-order', String(def.order));
      if (def.tooltip) proxy.setAttribute('data-tooltip', def.tooltip);
      proxy.setAttribute('aria-label', def.tooltip || 'Rewards');
      proxy.type = 'button';

      // Star icon — matches a typical rewards launcher appearance.
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'white');
      svg.setAttribute('width', '22');
      svg.setAttribute('height', '22');
      svg.setAttribute('aria-hidden', 'true');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute(
        'd',
        'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'
      );
      svg.appendChild(path);
      proxy.appendChild(svg);

      // Fallback click handler — only used before overlay activates.
      // Once the overlay is ready (see setupOverlay below), taps hit
      // the real Loloyal host element at z-index 10002, so this proxy
      // click never fires. Kept as a safety net for the brief window
      // between proxy creation and overlay readiness.
      proxy.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (el.shadowRoot) {
          const launcher = el.shadowRoot.querySelector('.loloyal-launcher');
          if (launcher) launcher.click();
        }
      });

      // Insert proxy at the correct flex order position.
      let proxyRef = null;
      const proxyChildren = target.children;
      for (let pi = 0; pi < proxyChildren.length; pi++) {
        const pOrder = parseFloat(proxyChildren[pi].getAttribute('data-floating-order') || 0);
        if (def.order < pOrder) {
          proxyRef = proxyChildren[pi];
          break;
        }
      }
      target.insertBefore(proxy, proxyRef);

      // ── Overlay setup ────────────────────────────────────────────────
      // Once the shadow root is ready, transition from proxy-click mode
      // to overlay mode. The host element is repositioned over the proxy
      // and the inner .loloyal-launcher is made transparent but clickable.
      // Native taps land on the real element — no programmatic .click().
      //
      // Uses setInterval instead of fixed delays — on slow mobile
      // connections, Loloyal's shadow root can take 10+ seconds to
      // initialize. The old 5-retry / 3.5s window caused the button
      // to appear but not work until the page was reloaded.
      const overlayTimer = setInterval(function () {
        const sr = el.shadowRoot;
        if (!sr) return;

        const inner = sr.querySelector('.loloyal-launcher');
        if (!inner) return;

        // Colour may not be computed yet — skip this tick, retry next
        const bg = window.getComputedStyle(inner).backgroundColor;
        if (!bg || bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent') return;

        // ── All prerequisites met — activate overlay ──────────────
        clearInterval(overlayTimer);

        // Sync colour to proxy + Swym
        proxy.style.setProperty('background', bg, 'important');
        const swym = containerRight.querySelector('[data-floating-btn="swym"]');
        if (swym) swym.style.setProperty('background', bg, 'important');

        // Guest: hide launcher entirely, skip overlay
        if (window.__ccfGuest) {
          if (!sr.querySelector('#ccf-loloyal-guest-hide')) {
            const gs = document.createElement('style');
            gs.id = 'ccf-loloyal-guest-hide';
            gs.textContent = '.loloyal-launcher { display: none !important; }';
            sr.appendChild(gs);
          }
          return;
        }

        // Inject style: make inner launcher transparent, fill host area,
        // but keep it in the layout with pointer-events so native taps
        // hit it during browser hit-testing through the shadow DOM.
        if (!sr.querySelector('#ccf-overlay-style')) {
          const os = document.createElement('style');
          os.id = 'ccf-overlay-style';
          os.textContent =
            '.loloyal-launcher { opacity: 0 !important; position: absolute !important; width: 100% !important; height: 100% !important; top: 0 !important; left: 0 !important; pointer-events: auto !important; cursor: pointer !important; z-index: 999999 !important; margin: 0 !important; padding: 0 !important; border: none !important; border-radius: 0 !important; }';
          sr.appendChild(os);
        }

        // Transition host from clip-path hidden → overlay position.
        // Position it exactly over the proxy using the same CSS vars.
        el.style.removeProperty('clip-path');
        el.style.setProperty('pointer-events', 'auto', 'important');
        el.style.setProperty('position', 'fixed', 'important');
        el.style.setProperty('bottom', 'var(--floating-btn-bottom)', 'important');
        el.style.setProperty('left', 'var(--floating-btn-left)', 'important');
        el.style.setProperty('width', 'var(--floating-btn-size)', 'important');
        el.style.setProperty('height', 'var(--floating-btn-size)', 'important');
        el.style.setProperty('min-width', '0', 'important');
        el.style.setProperty('min-height', '0', 'important');
        el.style.setProperty('max-width', 'var(--floating-btn-size)', 'important');
        el.style.setProperty('max-height', 'var(--floating-btn-size)', 'important');
        el.style.setProperty('background', 'transparent', 'important');
        el.style.setProperty('border', 'none', 'important');
        el.style.setProperty('border-radius', '50%', 'important');
        el.style.setProperty('overflow', 'visible', 'important');
        el.style.setProperty('z-index', '10002', 'important');
        el.style.setProperty('cursor', 'pointer', 'important');
        el.style.setProperty('padding', '0', 'important');
        el.style.setProperty('margin', '0', 'important');
      }, 500);
      // Safety: stop polling after 30 s
      setTimeout(function () {
        clearInterval(overlayTimer);
      }, 30000);
      return;
    }

    // ── Standard adoption (Swym and any future buttons) ──────────────────
    if (target.contains(el)) return;

    el.setAttribute('data-floating-btn', def.id);

    let ref = null;
    const children = target.children;
    for (let i = 0; i < children.length; i++) {
      const childOrder = parseFloat(children[i].getAttribute('data-floating-order') || 0);
      if (def.order < childOrder) {
        ref = children[i];
        break;
      }
    }

    el.setAttribute('data-floating-order', def.order);
    if (def.tooltip) el.setAttribute('data-tooltip', def.tooltip);
    el.setAttribute('aria-label', def.tooltip || 'Wishlist');
    target.insertBefore(el, ref);
  }

  function scan() {
    APP_BUTTONS.forEach(function (def) {
      if (collected[def.id]) return;
      const el = document.querySelector(def.selector);
      if (el) adopt(def, el);
    });
  }

  // Initial scan (apps may already be loaded)
  scan();

  // Watch for late-injecting apps
  const observer = new MutationObserver(function () {
    if (!observer._pending) {
      observer._pending = true;
      requestAnimationFrame(function () {
        observer._pending = false;
        scan();
        // Stop observing once all buttons are collected
        if (Object.keys(collected).length >= APP_BUTTONS.length) {
          observer.disconnect();
        }
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Safety: stop observing after 30 s regardless (avoid perpetual overhead)
  setTimeout(function () {
    observer.disconnect();
  }, 30000);
})();

/* -- Guest: mirror Loloyal's panel open state onto <html> -- */
(function () {
  'use strict';

  // Guests get every Loloyal element hidden (snippets/floating-buttons.liquid)
  // except while the panel is open. Loloyal's own links open it through
  // /#loloyal-home, and its panel carries the sign-in card a guest needs.
  if (!window.__ccfGuest) return;

  const OPEN_CLASS = 'loloyal-iframe-page-open';
  const root = document.documentElement;

  function track(panel) {
    const sync = function () {
      root.classList.toggle('ccf-loloyal-open', panel.classList.contains(OPEN_CLASS));
    };
    sync();
    new MutationObserver(sync).observe(panel, { attributes: true, attributeFilter: ['class'] });
  }

  const existing = document.querySelector('.loloyal-iframe-page');
  if (existing) {
    track(existing);
    return;
  }

  const finder = new MutationObserver(function () {
    const panel = document.querySelector('.loloyal-iframe-page');
    if (!panel) return;
    finder.disconnect();
    track(panel);
  });
  finder.observe(document.body, { childList: true, subtree: true });
})();

/* ── Hide floating buttons while cart drawer is open ─────────────── */
(function () {
  'use strict';

  const right = document.getElementById('FloatingButtons');
  const left = document.getElementById('FloatingButtonsLeft');
  if (!right) return;

  function setHidden(hide) {
    const v = hide ? 'hidden' : '';
    right.style.visibility = v;
    right.style.pointerEvents = hide ? 'none' : '';
    if (left) {
      left.style.visibility = v;
      left.style.pointerEvents = hide ? 'none' : '';
    }
  }

  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
    setHidden(drawer.hasAttribute('open'));
    new MutationObserver(function () {
      setHidden(drawer.hasAttribute('open'));
    }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }
})();

/* ── Shopify admin preview bar: raise buttons above the 64px bar ─── */
(function () {
  'use strict';

  /* PolarisPortalsContainer is injected by Shopify's admin UI whenever
     the store owner visits the storefront while logged in to admin.
     The bar is ~64px tall (collapsed) and sits at the bottom of the
     viewport, covering our floating buttons at bottom:12px. */
  function adjustForAdminBar() {
    if (!document.getElementById('PolarisPortalsContainer')) return;

    /* Measure the actual bar height from its bounding rect so this
       works even if Shopify changes the exact pixel value. */
    const root = document.getElementById('root');
    let barHeight = 64; // safe fallback
    if (root) {
      const kids = root.querySelectorAll('[style*="height"]');
      for (let i = 0; i < kids.length; i++) {
        const r = kids[i].getBoundingClientRect();
        /* Bar is fixed at viewport bottom — bottom ≈ innerHeight, height < 120 */
        if (r.bottom >= window.innerHeight - 4 && r.height < 120 && r.height > 0) {
          barHeight = Math.ceil(r.height);
          break;
        }
      }
    }

    /* Raise both containers above the admin bar */
    const offset = barHeight + 12 + 'px';
    document.documentElement.style.setProperty('--floating-btn-bottom', offset);
  }

  /* Run immediately (bar may already be present) */
  adjustForAdminBar();

  /* Also catch late injection — admin bar arrives after page scripts */
  const obs = new MutationObserver(function () {
    if (document.getElementById('PolarisPortalsContainer')) {
      adjustForAdminBar();
      obs.disconnect();
    }
  });
  obs.observe(document.body, { childList: true, subtree: false });
  setTimeout(function () {
    obs.disconnect();
  }, 15000);
})();
